import { useEffect, useLayoutEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import useMedia from "use-media";
import commonUtil from "../../../common/commonUtil";
import CommonValidation from "../../../common/commonValidation";
import { apiKeyCheck, versionGetApi } from "../../../const";
import { getAirportList, getFlightInfo } from "../../../const/RTCC";
import MessageConst from '../../../const/RTCC/messageConst';
import { useRtoaster } from "../../../hooks/useRtoaster";
import common from "../../../resources/RTCC/js/common/common";
import { Button } from "../../atoms/RTCC/button";
import { Label } from '../../atoms/RTCC/label';
import { AirportOptionForm } from '../../molecules/RTCC/airportOptionForm';
import { BreadCrumb } from '../../molecules/RTCC/breadCrumb';
import { ErrorMassage } from "../../molecules/RTCC/errorMassage";
import { FlightTimeForm } from '../../molecules/RTCC/flightTimeForm';
import { LabelInputForm } from '../../molecules/RTCC/labelInputForm';
import { ModalOptionForm } from '../../molecules/RTCC/modalOptionForm';
import './../../../resources/RTCC/css/flight/flight.css';
import { FooterContainer } from './footerContainer';

const RtccInputFlightContainer = (props) => {
    const {
        state,
        login,
        toUserInputInfo,
        setToUserInputInfo,
        onChange,
        onClickOpenCalendarWindow,
        checkIn,
        checkOut,
        confirmText,
        inputFlightInfo,
        setInputFlightInfo
    } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    const history = useHistory();
    const store = useStore();

    const [linkList, setLinkList] = useState([]);
    const [airportList, setAirportList] = useState([]);
    const [outFlightInfo, setOutFlightInfo] = useState({});
    const [inFlightInfo, setInFlightInfo] = useState({});

    const [errorInfo, setErrorInfo] = useState({ errorMessage: null, errorFlg: false, });
    const [validFlg, setValidFlg] = useState(false);

    // rtoasterタグ生成
    useRtoaster();

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);
        window.scroll({ top: 0, behavior: 'smooth' })
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
        setToUserInputInfo(toUserInputInfo);
        setLinkList([{ path: "/reserve/top", label: "HOME" }, { path: "/reserve/rtcc/reservation", label: "RTCC予約" }]);
        // 空港マスタ一覧取得
        common.doPost(getAirportList, {}, afterGetAirportList);
        // フライト情報取得
        common.doPost(getFlightInfo, { reserveId: toUserInputInfo.reserveId }, afterGetFlightInfo);
    }, []);

    const afterGetAirportList = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            let airports = commonUtil.getSelectList(data.airport, "airportId", "airportName", true, "空港を選択する");
            setAirportList(airports);
        }
    }

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    const afterGetFlightInfo = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            setOutFlightInfo({
                outDepartureAirportId: data.outFlightInfo.departureAirportId,
                outArrivalAirportId: data.outFlightInfo.arrivalAirportId,
                outBordingDate: data.outFlightInfo.bordingDate,
                outBordingHour: data.outFlightInfo.bordingTime ? data.outFlightInfo.bordingTime.slice(0, 2) : "",
                outBordingMinute: data.outFlightInfo.bordingTime ? data.outFlightInfo.bordingTime.slice(-2) : "",
                outAirline: data.outFlightInfo.airlineName,
                outFlight: data.outFlightInfo.flightNumber
            });
            setInFlightInfo({
                inDepartureAirportId: data.inFlightInfo.departureAirportId,
                inArrivalAirportId: data.inFlightInfo.arrivalAirportId,
                inBordingDate: data.inFlightInfo.bordingDate,
                inBordingHour: data.inFlightInfo.bordingTime ? data.inFlightInfo.bordingTime.slice(0, 2) : "",
                inBordingMinute: data.inFlightInfo.bordingTime ? data.inFlightInfo.bordingTime.slice(-2) : "",
                inAirline: data.inFlightInfo.airlineName,
                inFlight: data.inFlightInfo.flightNumber
            });
            setInputFlightInfo({
                goBoardingDate: data.outFlightInfo.bordingDate,
                backBoardingDate: data.inFlightInfo.bordingDate,
            });
        } else {
            let goBoarding = new Date(inputFlightInfo.goBoardingDate);
            let backBoarding = new Date(inputFlightInfo.backBoardingDate);
            setInputFlightInfo({
                goBoardingDate: goBoarding,
                backBoardingDate: backBoarding,
            });
        }
    }

    // フライト情報入力
    const handleFlightInfo = (form, outOrIn) => {
        let input = document.getElementById(form).value;
        if (outOrIn == "out") {
            setOutFlightInfo({ ...outFlightInfo, [form]: input });
        } else {
            setInFlightInfo({ ...inFlightInfo, [form]: input });
        }
    }

    // 「戻る」ボタン押下時
    const onClickBack = () => { history.push("/reserve/rtcc/bookingConfirmDetail"); }

    // 「確認画面へ」ボタン押下時
    const onClickCheckInput = () => {
        let outDepartureAirportId = document.getElementById("outDepartureAirportId").value;
        let outDepartureAirportName = airportList.find(value => value.id == outDepartureAirportId);
        let outArrivalAirportId = document.getElementById("outArrivalAirportId").value;
        let outArrivalAirportName = airportList.find(value => value.id == outArrivalAirportId);
        let goBoardingDate = document.getElementById("goBoardingDate").textContent;
        let outBordingHour = document.getElementById("outBordingHour").value;
        let outBordingMinute = document.getElementById("outBordingMinute").value;
        let outAirline = document.getElementById("outAirline").value;
        let outFlight = document.getElementById("outFlight").value;
        let inDepartureAirportId = document.getElementById("inDepartureAirportId").value;
        let inDepartureAirportName = airportList.find(value => value.id == inDepartureAirportId);
        let inArrivalAirportId = document.getElementById("inArrivalAirportId").value;
        let inArrivalAirportName = airportList.find(value => value.id == inArrivalAirportId);
        let backBoardingDate = document.getElementById("backBoardingDate").textContent;
        let inBordingHour = document.getElementById("inBordingHour").value;
        let inBordingMinute = document.getElementById("inBordingMinute").value;
        let inAirline = document.getElementById("inAirline").value;
        let inFlight = document.getElementById("inFlight").value;
        // 入力チェック
        let flgList = {
            errValid: false,
            errOutDepartureAirportId: false,
            errOutArrivalAirportId: false,
            errInDepartureAirportId: false,
            errInArrivalAirportId: false,
            errOutAirline: false,
            errOutFlight: false,
            errInAirline: false,
            errInFlight: false,
        }
        let errorMessageBox = [];
        if (CommonValidation.Require(outDepartureAirportId)) {
            flgList.errValid = true;
            flgList.errOutDepartureAirportId = true;
        }
        if (CommonValidation.Require(outArrivalAirportId)) {
            flgList.errValid = true;
            flgList.errOutArrivalAirportId = true;
        }
        if (CommonValidation.Require(inDepartureAirportId)) {
            flgList.errValid = true;
            flgList.errInDepartureAirportId = true;
        }
        if (CommonValidation.Require(inArrivalAirportId)) {
            flgList.errValid = true;
            flgList.errInArrivalAirportId = true;
        }
        if (CommonValidation.Require(outAirline)) {
            flgList.errValid = true;
            flgList.errOutAirline = true;
        } 
        if (CommonValidation.Require(outFlight)) {
            flgList.errValid = true;
            flgList.errOutFlight = true;
        } 
        if (CommonValidation.Require(inAirline)) {
            flgList.errValid = true;
            flgList.errInAirline = true;
        } 
        if (CommonValidation.Require(inFlight)) {
            flgList.errValid = true;
            flgList.errInFlight = true;
        } 
        setValidFlg(flgList);
        if (flgList.errValid) {
            errorMessageBox.push(MessageConst.INPUT_ERROR);
            setErrorInfo({ errorMessage: errorMessageBox, errorFlg: true });
            window.scroll({ top: 500, behavior: 'smooth' })
        } else {
            setInputFlightInfo({
                reserveId: toUserInputInfo.reserveId,
                outFlightInfo: {
                    departureAirportId: outDepartureAirportId,
                    departureAirportName: outDepartureAirportName ? outDepartureAirportName.value : "",
                    arrivalAirportId: outArrivalAirportId,
                    arrivalAirportName: outArrivalAirportName ? outArrivalAirportName.value : "",
                    bordingDate: goBoardingDate,
                    bordingTime: outBordingHour + outBordingMinute,
                    airlineName: outAirline,
                    flightNumber: outFlight
                },
                inFlightInfo: {
                    departureAirportId: inDepartureAirportId,
                    departureAirportName: inDepartureAirportName ? inDepartureAirportName.value : "",
                    arrivalAirportId: inArrivalAirportId,
                    arrivalAirportName: inArrivalAirportName ? inArrivalAirportName.value : "",
                    bordingDate: backBoardingDate,
                    bordingTime: inBordingHour + inBordingMinute,
                    airlineName: inAirline,
                    flightNumber: inFlight
                },
                loginId: login.memberCode,
                goBoardingDate: inputFlightInfo.goBoardingDate,
                backBoardingDate: inputFlightInfo.backBoardingDate,
            });
            setErrorInfo({ errorMessage: [], errorFlg: false });
            history.push("inputFlightConfirm");
        }
    }

    // 行き搭乗日表示処理
    const getDateToString = () => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        let goBoarding = new Date();
        if (inputFlightInfo.goBoardingDate) {
            goBoarding = new Date(inputFlightInfo.goBoardingDate);
        } else {
            return toUserInputInfo.startDate;
        }
        const y = goBoarding.getFullYear();
        const m = goBoarding.getMonth() + 1;
        const d = goBoarding.getDate();

        return `${y}年${m}月${d}日（${youbi[goBoarding.getDay()]}）`;
    }
    // 帰り搭乗日表示処理
    const getDateToString2 = () => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        let backBoarding = new Date();
        if (inputFlightInfo.backBoardingDate) {
            backBoarding = new Date(inputFlightInfo.backBoardingDate);
        } else {
            return toUserInputInfo.endDate;
        }
        const y = backBoarding.getFullYear();
        const m = backBoarding.getMonth() + 1;
        const d = backBoarding.getDate();

        return `${y}年${m}月${d}日（${youbi[backBoarding.getDay()]}）`;
    }

    return (
        <div className="userInputInnerWrapper">
            <BreadCrumb
                breadCrumbStyle={isWideTablet ? { display: "none" } : styles.breadCrumb}
                linkStyle={styles.link}
                linkList={linkList}
                lastLabel="フライト情報入力"
                lastLabelClassName="lastLabel"
            />
            <div style={isWideTablet ? styles.breadCrumb2 : { display: "none" }}></div>
            <div style={errorInfo.errorFlg ? styles.errorDiv : { display: "none" }}>
                <ErrorMassage style={styles.errorMassage} data={errorInfo.errorMessage} />
            </div>
            <div className="reserveConirmWrapper">
                <div className="reserveContentWrapper">
                    <Label label="ご予約内容" className="reserveConirmTitle2" />
                    <div className="reservationContentsWrap">
                        <div className="reservationContents">
                            <Label label="ご利用日程" className="inputTitleLabel" />
                            <Label
                                label={toUserInputInfo.startDate + "\n" + "～" + "\n" + toUserInputInfo.endDate}
                                className="rtcc_inputContentLabel"
                            />
                        </div>
                        <div className="reservationContents">
                            <Label label="施設名" className="inputTitleLabel" />
                            <Label
                                label={toUserInputInfo.hotelName}
                                className="rtcc_inputContentLabel"
                            />
                        </div>
                        <div className="reservationContents">
                            <Label label="お部屋タイプ" className="inputTitleLabel" />
                            <Label
                                label={toUserInputInfo.roomType}
                                className="rtcc_inputContentLabel"
                            />
                        </div>
                        <div className="reservationContents">
                            <Label label="予約番号" className="inputTitleLabel" />
                            <Label
                                label={toUserInputInfo.reserveId}
                                className="rtcc_inputContentLabel"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="userInputWrapper">
                <div className="userInput5">
                    <Label label={"行き"} className="flightTitleLabel" />
                    <AirportOptionForm
                        list={airportList}
                        wrapClassName={validFlg.errOutDepartureAirportId ? "flightPullDownErrWrap" : "flightPullDownWrap"}
                        labelClassName="popupLabel"
                        className={validFlg.errOutDepartureAirportId ? "datePullDownButtonError -long" : "datePullDownButton -long"}
                        id="outDepartureAirportId"
                        label={"出発地"}
                        pullDownAreaStyle={styles.pullDownArea}
                        state={outFlightInfo.outDepartureAirportId}
                        onChange={handleFlightInfo}
                        outOrIn="out"
                    />
                    <AirportOptionForm
                        list={airportList}
                        wrapClassName={validFlg.errOutArrivalAirportId ? "flightPullDownErrWrap" : "flightPullDownWrap"}
                        labelClassName="popupLabel"
                        className={validFlg.errOutArrivalAirportId ? "datePullDownButtonError -long" : "datePullDownButton -long"}
                        id="outArrivalAirportId"
                        label={"到着地"}
                        pullDownAreaStyle={styles.pullDownArea}
                        state={outFlightInfo.outArrivalAirportId}
                        onChange={handleFlightInfo}
                        outOrIn="out"
                    />
                    <ModalOptionForm
                        id={"goBoardingDate"}
                        wrapClassName="popupWrapLong"
                        labelClassName="popupLabel" title={"搭乗日"}
                        className="popupButton"
                        onClick={onClickOpenCalendarWindow}
                        text={getDateToString()}
                    />
                    <div className="birthDateArea">
                        <Label label={"出発時間"} className="popupLabel" />
                        <div style={{ display: "flex" }}>
                            <FlightTimeForm
                                wrapClassName="flightPullDownWrap"
                                labelClassName="popupLabel"
                                className="datePullDownButton"
                                hourId="outBordingHour"
                                minuteId="outBordingMinute"
                                hourTitle="時"
                                minitTitle="分"
                                pullDownAreaStyle={styles.pullDownArea}
                                onChange={handleFlightInfo}
                                hourValue={outFlightInfo.outBordingHour}
                                minuteValue={outFlightInfo.outBordingMinute}
                                outOrIn="out"
                                hourLabel="hourLabel"
                                minuteLabel="hourLabel"
                            />
                        </div>
                    </div>
                    <LabelInputForm
                        label={"航空会社"}
                        type={"id"}
                        id="outAirline"
                        placeholder="ANA"
                        value={outFlightInfo.outAirline}
                        className={validFlg.errOutAirline ? "inputKeywordError" : "inputKeyword"}
                        onChange={() => handleFlightInfo("outAirline", "out")}
                        labelClassName="popupLabel"
                        wrapClassName="popupWrapLong"
                        labelWrap="confirmLabelTextWrap flightInput"
                    />
                    <LabelInputForm
                        label={"便名"}
                        type={"id"}
                        id="outFlight"
                        placeholder="AA015"
                        value={outFlightInfo.outFlight}
                        className={validFlg.errOutFlight ? "inputKeywordError" : "inputKeyword"}
                        onChange={() => handleFlightInfo("outFlight", "out")}
                        labelClassName="popupLabel"
                        wrapClassName="popupWrapLong"
                        labelWrap="confirmLabelTextWrap flightInput"
                    />
                </div>
            </div>
            <div className="userInputWrapper">
                <div className="userInput5">
                    <Label label={"帰り"} className="flightTitleLabel" />
                    <AirportOptionForm
                        list={airportList}
                        wrapClassName={validFlg.errInDepartureAirportId ? "flightPullDownErrWrap" : "flightPullDownWrap"}
                        labelClassName="popupLabel"
                        className={validFlg.errInDepartureAirportId ? "datePullDownButtonError -long" : "datePullDownButton -long"}
                        id="inDepartureAirportId"
                        label={"出発地"}
                        pullDownAreaStyle={styles.pullDownArea}
                        state={inFlightInfo.inDepartureAirportId}
                        onChange={handleFlightInfo}
                        outOrIn="in"
                    />
                    <AirportOptionForm
                        list={airportList}
                        wrapClassName={validFlg.errInArrivalAirportId ? "flightPullDownErrWrap" : "flightPullDownWrap"}
                        labelClassName="popupLabel"
                        className={validFlg.errInArrivalAirportId ? "datePullDownButtonError -long" : "datePullDownButton -long"}
                        id="inArrivalAirportId"
                        label={"到着地"}
                        pullDownAreaStyle={styles.pullDownArea}
                        state={inFlightInfo.inArrivalAirportId}
                        onChange={handleFlightInfo}
                        outOrIn="in"
                    />
                    <ModalOptionForm
                        id={"backBoardingDate"}
                        wrapClassName="popupWrapLong"
                        labelClassName="popupLabel" title={"搭乗日"}
                        className="popupButton"
                        onClick={onClickOpenCalendarWindow}
                        text={getDateToString2()}
                    />
                    <div className="birthDateArea">
                        <Label label={"出発時間"} className="popupLabel" />
                        <div style={{ display: "flex" }}>
                            <FlightTimeForm
                                wrapClassName="flightPullDownWrap"
                                labelClassName="popupLabel"
                                className="datePullDownButton"
                                hourId="inBordingHour"
                                minuteId="inBordingMinute"
                                hourTitle="時"
                                minitTitle="分"
                                pullDownAreaStyle={styles.pullDownArea}
                                onChange={handleFlightInfo}
                                hourValue={inFlightInfo.inBordingHour}
                                minuteValue={inFlightInfo.inBordingMinute}
                                outOrIn="in"
                                hourLabel="hourLabel"
                                minuteLabel="hourLabel"
                            />
                        </div>
                    </div>
                    <LabelInputForm
                        label={"航空会社"}
                        type={"id"}
                        id="inAirline"
                        placeholder="ANA"
                        value={inFlightInfo.inAirline}
                        className={validFlg.errInAirline ? "inputKeywordError" : "inputKeyword"}
                        onChange={() => handleFlightInfo("inAirline", "in")}
                        labelClassName="popupLabel"
                        wrapClassName="popupWrapLong"
                        labelWrap="confirmLabelTextWrap flightInput"
                    />
                    <LabelInputForm
                        label={"便名"}
                        type={"id"}
                        id="inFlight"
                        placeholder="AA015"
                        value={inFlightInfo.inFlight}
                        className={validFlg.errInFlight ? "inputKeywordError" : "inputKeyword"}
                        onChange={() => handleFlightInfo("inFlight", "in")}
                        labelClassName="popupLabel"
                        wrapClassName="popupWrapLong"
                        labelWrap="confirmLabelTextWrap flightInput"
                    />
                </div>
            </div>
            <div className="btnToConfirmWrapper">
                <div className="confirmboxWrap">
                    <Button buttonText="戻る" className="btnBack" onClick={onClickBack} buttonClassName="serachBtnText" />
                    <Button buttonText="確認画面へ" className="btnToConfirm" onClick={onClickCheckInput} buttonClassName="serachBtnText" />
                </div>
                <div className="flightToTop">
                    <Link to={"/reserve/rtcc/reservation"} style={styles.bottomLink}>RTCC検索TOPへ戻る</Link>
                </div>
            </div>
            <div style={styles.footer}>
                <FooterContainer className={"reservationResultFooterBase"} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        login: state.login,
        checkIn: state.checkIn,
        group: state.group,
        room: state.room,
        human: state.human,
        course: state.course,
        detailCondition: state.detailCondition,
        startTime: state.startTime,
        login: state.login,
        kaiinken: state.kaiinken,
        area: state.area,
        country: state.country,
        city: state.city,
        checkOut: state.checkOut,
        toUserInputInfo: state.toUserInputInfo,
        confirmText: state.confirmText,
        inputFlightInfo: state.inputFlightInfo,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setDetailCondition: (item) => {
            dispatch({ type: "DETAIL_CONDITION", payload: { detailCondition: item } })
        },
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setStartTime: (item) => {
            dispatch({ type: "START_TIME", payload: { startTime: item } })
        },
        setGroup: (item) => {
            dispatch({ type: "GROUP", payload: { group: item } })
        },
        setRoom: (item) => {
            dispatch({ type: "ROOM", payload: { room: item } })
        },
        setHuman: (item) => {
            dispatch({ type: "HUMAN", payload: { human: item } })
        },
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setKaiinken: (item) => {
            dispatch({ type: "KAIINKEN", payload: { kaiinken: item } })
        },
        setArea: (item) => {
            dispatch({ type: "AREA", payload: { area: item } })
        },
        setCountry: (item) => {
            dispatch({ type: "COUNTRY", payload: { country: item } })
        },
        setCity: (item) => {
            dispatch({ type: "CITY", payload: { city: item } })
        },
        setCheckIn: (item) => {
            dispatch({ type: "CHECKIN", payload: { checkIn: item } })
        },
        setToUserInputInfo: (item) => {
            dispatch({ type: "TO_USERINPUT_INFO", payload: { toUserInputInfo: item } })
        },
        setInputFlightInfo: (item) => {
            dispatch({ type: "INPUT_FLIGHT_INFO", payload: { inputFlightInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(RtccInputFlightContainer);

const styles = {
    firstRoomWrapper: {
        width: "80%",
        margin: "0px auto",
        backgroundColor: "#808080",
        padding: "10px 10% 10px 10%",
    },
    userInput: {
        display: "block",
        flexWrap: "wrap",
    },
    roomNum: {
        display: "flex",
        padding: "20px 0px 20px 0px",
        marginBottom: "20px",
        justifyContent: "space-between",
        borderBottom: "1px solid #bfbec5",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    bottomLinkArea: {
        marginTop: "30px",
        paddingTop: "40px",
        textAlign: "center",
        borderTop: "1px solid rgb(204, 204, 204);",
    },
    bottomLink: {
        padding: "3px",
        color: "#696969",
        fontSize: "small",
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        padding: "8px 0px 30px 0px",
    },
    breadCrumb2: {
        marginBottom: "30px",
    },
    breadCrumbArrow: {
        marginRight: "5px",
        marginLeft: "5px",
        marginTop: "1px",
        fontSize: "small",
    },
    footer: {
        width: "80%",
        padding: "30px 10% 10px 10%",
        whiteSpace: "nowrap",
        color: "white",
        fontWeight: "300",
    },
    genderWrap: {
        marginBottom: "20px",
    },
    gender: {
        display: "flex",
    },
    genderLabel: {
        margin: "0px 30px 0px 10px",
    },
    confirmbox: {
        width: "100%",
        display: "flex",
        borderTop: "1px solid rgb(191, 190, 197)",
        borderBotttom: "1px solid rgb(191, 190, 197)",
        padding: "30px 0px",
    },
    paymentOption: {
        display: "flex",
        marginTop: "20px",
    },
    fee: {
        display: "flex",
        justifyContent: "space-between",
    },
    pullDownArea: {
        display: "flex",
        alignItems: "center"
    },
    reservationInfo: {
        display: "flex",
        justifyContent: "space-between",
        margin: "20px 60px 20px 100px",
    },
    errorMassage: {
        display: "inline-block",
        textAlign: "left",
        padding: "0px 0px 0px 0px",
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0.94)",
        border: 0,
        fontWeight: "bold"
    }
}